exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-form-field{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/import-export/import-export/import-export.component.styl
// module id = 1072
// module chunks = 0